(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["Maps"] = factory(require("react"));
	else
		root["Maps"] = factory(root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9787__) => {
return 